var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercardLogotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.41 16.897H16.316v21.852H28.41V16.897Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.084 27.823c0-4.44 2.073-8.378 5.26-10.926a13.688 13.688 0 0 0-8.523-2.973C6.181 13.924 0 20.14 0 27.823 0 35.506 6.18 41.72 13.82 41.72c3.225 0 6.181-1.12 8.523-2.972a13.965 13.965 0 0 1-5.26-10.926Z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.726 27.823c0 7.683-6.18 13.898-13.82 13.898-3.226 0-6.182-1.12-8.524-2.972a13.965 13.965 0 0 0 5.26-10.926c0-4.44-2.073-8.378-5.298-10.926 2.38-1.853 5.336-2.973 8.561-2.973 7.64 0 13.821 6.216 13.821 13.899Z",
    fill: "#B8B8B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogotype);
export default __webpack_public_path__ + "static/media/mastercard-logotype.c1dd9fc62eb839a52f21ad520df656ce.svg";
export { ForwardRef as ReactComponent };